var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Lifecycle, delay, inject, scoped } from 'tsyringe';
import { ConfigInjectionToken } from '../ConfigTypes';
import { DestroySignal } from '../DestroySignal';
import { StreamRegistry } from '../contracts/StreamRegistry';
import { StreamStorageRegistry } from '../contracts/StreamStorageRegistry';
import { GroupKeyManager } from '../encryption/GroupKeyManager';
import { SignatureValidator } from '../signature/SignatureValidator';
import { LoggerFactory } from '../utils/LoggerFactory';
import { createMessagePipeline as _createMessagePipeline } from './messagePipeline';
import { Tokens } from '../tokens';
let MessagePipelineFactory = class MessagePipelineFactory {
    resends;
    streamStorageRegistry;
    streamRegistry;
    signatureValidator;
    groupKeyManager;
    config;
    destroySignal;
    loggerFactory;
    /* eslint-disable indent */
    constructor(resends, streamStorageRegistry, streamRegistry, signatureValidator, groupKeyManager, config, destroySignal, loggerFactory) {
        this.resends = resends;
        this.streamStorageRegistry = streamStorageRegistry;
        this.streamRegistry = streamRegistry;
        this.signatureValidator = signatureValidator;
        this.groupKeyManager = groupKeyManager;
        this.config = config;
        this.destroySignal = destroySignal;
        this.loggerFactory = loggerFactory;
    }
    createMessagePipeline(opts) {
        return _createMessagePipeline({
            ...opts,
            getStorageNodes: opts.getStorageNodes ?? ((streamId) => this.streamStorageRegistry.getStorageNodes(streamId)),
            resends: this.resends,
            streamRegistry: this.streamRegistry,
            signatureValidator: this.signatureValidator,
            groupKeyManager: this.groupKeyManager,
            config: opts.config ?? this.config,
            destroySignal: this.destroySignal,
            loggerFactory: this.loggerFactory
        });
    }
};
MessagePipelineFactory = __decorate([
    scoped(Lifecycle.ContainerScoped),
    __param(0, inject(Tokens.Resends)),
    __param(2, inject(delay(() => StreamRegistry))),
    __param(4, inject(delay(() => GroupKeyManager))),
    __param(5, inject(ConfigInjectionToken)),
    __metadata("design:paramtypes", [Function, StreamStorageRegistry,
        StreamRegistry,
        SignatureValidator,
        GroupKeyManager, Object, DestroySignal,
        LoggerFactory])
], MessagePipelineFactory);
export { MessagePipelineFactory };
//# sourceMappingURL=MessagePipelineFactory.js.map